import { PLATFORM_REGEXS } from '../constants'

const referrerIncludesPlatform = (...platforms) => {
  return traffic => {
    if (traffic.referrer === '') {
      return false
    }
    const referrerObject = new URL(traffic.referrer.toLowerCase())
    const hostname = referrerObject.hostname
    return platforms.some(platform => {
      return PLATFORM_REGEXS[platform].some(regex => regex.test(hostname))
    })
  }
}

export default referrerIncludesPlatform



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/referrerIncludesPlatform.js